export default __webpack_public_path__ + "static/media/avatar7.d4f3a9f0.jpg";